import {useParentCompanies} from '@api'
import {activeCell, isSuperAdmin, renderClickableCell, useViewNavigate} from '@common'
import {NavigationPathKey, TranslationKey} from '@enums'
import {GridColDef} from '@mui/x-data-grid'
import {pageLinksAtom} from '@state'

import {useEffect, useMemo} from 'react'

import {useSetAtom} from 'jotai'
import {useTranslation} from 'react-i18next'

export interface CompanyTableData {
  name: string
  description: string
  active: boolean
}

export function useParentCompanySearchModel() {
  const setTitleLinks = useSetAtom(pageLinksAtom)
  const {t} = useTranslation()
  const navigate = useViewNavigate()

  const {data} = useParentCompanies()
  const rows = useMemo(() => {
    if (!data) return []
    return data.map(item => ({
      name: item.name,
      description: item.description,
      active: item.active,
      id: item.id,
    }))
  }, [data])

  useEffect(
    () =>
      setTitleLinks([
        {title: t(TranslationKey['Admin panel']), link: NavigationPathKey.ADMIN_PANEL},
        {title: t(TranslationKey.Resources), link: NavigationPathKey.RESOURCES_DASHBOARD},
        {
          title: t(TranslationKey['Amplio partners']),
        },
      ]),
    [],
  )

  /**
   * Company table columns definition
   */
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t(TranslationKey.Name),
      flex: 0.8,
      hideable: false,
      renderCell: params =>
        renderClickableCell(params, () => navigate(`${NavigationPathKey.PARENT_COMPANY_VIEW}/${params.row.id}`)),
    },
    {field: 'description', headerName: t(TranslationKey.Description), flex: 1},
    activeCell(t),
  ]

  /**
   * Create button should be visible only for Super Administrators
   */
  const showCreateButton = isSuperAdmin()

  return {navigate, t, showCreateButton, rows, columns}
}
